import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import RichTextEditor from '../RichTextEditor';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { Plus, Trash2, Edit2 } from 'lucide-react';
import { API } from './adminUtils';

export function VehiclesTab({
  showVehicleForm, setShowVehicleForm, setEditingVehicleId, setVehicleForm, emptyVehicleForm,
  openAddVehicle, editingVehicleId, handleAddVehicle, vehicleForm, vehicleSubmitting,
  vehicles, openEditVehicle, handleDeleteVehicle,
}) {
  return (
    <>
      <div className="flex justify-end mb-4">
        <Dialog open={showVehicleForm} onOpenChange={(o) => { setShowVehicleForm(o); if (!o) { setEditingVehicleId(null); setVehicleForm(emptyVehicleForm); } }}>
          <DialogTrigger asChild>
            <Button className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="admin-add-vehicle-btn" onClick={openAddVehicle}>
              <Plus className="w-4 h-4 mr-2" /> Araç Ekle
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
            <DialogHeader><DialogTitle>{editingVehicleId ? 'Aracı Düzenle' : 'Kataloga Araç Ekle'}</DialogTitle></DialogHeader>
            <form onSubmit={handleAddVehicle} className="space-y-3 mt-2">
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <Label>Marka</Label>
                  <Input value={vehicleForm.brand} onChange={e => setVehicleForm(p => ({...p, brand: e.target.value}))} placeholder="Örn: Citroen" className="mt-1" data-testid="admin-vehicle-brand" required />
                </div>
                <div>
                  <Label>Model</Label>
                  <Input value={vehicleForm.model} onChange={e => setVehicleForm(p => ({...p, model: e.target.value}))} placeholder="Örn: Ami" className="mt-1" data-testid="admin-vehicle-model" required />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-3">
                <div>
                  <Label>Kategori</Label>
                  <Select value={vehicleForm.category} onValueChange={v => setVehicleForm(p => ({...p, category: v}))}>
                    <SelectTrigger className="mt-1" data-testid="admin-vehicle-category">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="L6e">L6e</SelectItem>
                      <SelectItem value="L7e">L7e</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label>Yıl</Label>
                  <Input type="number" value={vehicleForm.year} onChange={e => setVehicleForm(p => ({...p, year: parseInt(e.target.value)}))} className="mt-1" data-testid="admin-vehicle-year" />
                </div>
                <div>
                  <Label>Max Hız (km/s)</Label>
                  <Input type="number" value={vehicleForm.max_speed} onChange={e => setVehicleForm(p => ({...p, max_speed: parseInt(e.target.value)}))} className="mt-1" data-testid="admin-vehicle-speed" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-3">
                <div>
                  <Label>Menzil (km)</Label>
                  <Input type="number" value={vehicleForm.range_km} onChange={e => setVehicleForm(p => ({...p, range_km: parseInt(e.target.value)}))} className="mt-1" />
                </div>
                <div>
                  <Label>Batarya (kWh)</Label>
                  <Input type="number" step="0.1" value={vehicleForm.battery_kwh} onChange={e => setVehicleForm(p => ({...p, battery_kwh: parseFloat(e.target.value)}))} className="mt-1" />
                </div>
                <div>
                  <Label>Koltuk Sayısı</Label>
                  <Input type="number" value={vehicleForm.seats} onChange={e => setVehicleForm(p => ({...p, seats: parseInt(e.target.value)}))} className="mt-1" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-3">
                <div>
                  <Label>Motor (kW)</Label>
                  <Input type="number" step="0.1" value={vehicleForm.power_kw} onChange={e => setVehicleForm(p => ({...p, power_kw: parseFloat(e.target.value)}))} className="mt-1" />
                </div>
                <div>
                  <Label>Ağırlık (kg)</Label>
                  <Input type="number" value={vehicleForm.weight_kg} onChange={e => setVehicleForm(p => ({...p, weight_kg: parseInt(e.target.value)}))} className="mt-1" />
                </div>
                <div>
                  <Label>Ehliyet</Label>
                  <Input value={vehicleForm.license_required} onChange={e => setVehicleForm(p => ({...p, license_required: e.target.value}))} placeholder="AM, B1, B" className="mt-1" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <Label>Min Fiyat (₺)</Label>
                  <Input type="number" value={vehicleForm.price_min} onChange={e => setVehicleForm(p => ({...p, price_min: parseInt(e.target.value)}))} className="mt-1" />
                </div>
                <div>
                  <Label>Max Fiyat (₺)</Label>
                  <Input type="number" value={vehicleForm.price_max} onChange={e => setVehicleForm(p => ({...p, price_max: parseInt(e.target.value)}))} className="mt-1" />
                </div>
              </div>
              <div>
                <Label>Görsel URL</Label>
                <Input value={vehicleForm.image_url} onChange={e => setVehicleForm(p => ({...p, image_url: e.target.value}))} placeholder="https://..." className="mt-1" data-testid="admin-vehicle-image" />
              </div>
              <div>
                <Label>Açıklama</Label>
                <div className="mt-1" data-testid="admin-vehicle-desc">
                  <RichTextEditor
                    value={vehicleForm.description}
                    onChange={v => setVehicleForm(p => ({...p, description: v}))}
                    placeholder="Araç hakkında detaylı açıklama..."
                    minHeight={160}
                  />
                </div>
              </div>
              <Button type="submit" disabled={vehicleSubmitting} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="admin-vehicle-submit">
                {vehicleSubmitting ? (editingVehicleId ? 'Kaydediliyor...' : 'Ekleniyor...') : (editingVehicleId ? 'Değişiklikleri Kaydet' : 'Araç Ekle')}
              </Button>
            </form>
          </DialogContent>
        </Dialog>
      </div>
      <div className="bg-white rounded-2xl border border-slate-200 divide-y divide-slate-50">
        {vehicles.map(v => (
          <div key={v._id} data-testid={`admin-vehicle-${v._id}`} className="flex items-center gap-4 px-4 py-3 flex-wrap sm:flex-nowrap">
            {v.image_url && (
              <img src={v.image_url.startsWith('http') ? v.image_url : `${API}/files/${v.image_url}`}
                alt={v.model} className="w-12 h-10 object-cover rounded-lg shrink-0" />
            )}
            <div className="flex-1 min-w-0">
              <span className={`text-xs font-bold px-2 py-0.5 rounded-full mr-2 ${v.category === 'L6e' ? 'bg-emerald-100 text-emerald-700' : 'bg-cyan-100 text-cyan-700'}`}>{v.category}</span>
              <span className="font-medium text-slate-800">{v.brand} {v.model}</span>
              <span className="text-xs text-slate-400 ml-2">{v.year}</span>
            </div>
            <div className="flex items-center gap-1 shrink-0">
              <button onClick={() => openEditVehicle(v)} className="p-1.5 rounded-lg text-slate-400 hover:text-emerald-600 hover:bg-emerald-50 transition-colors" data-testid={`admin-edit-vehicle-${v._id}`} title="Düzenle">
                <Edit2 className="w-3.5 h-3.5" />
              </button>
              <button onClick={() => handleDeleteVehicle(v._id)} className="p-1.5 rounded-lg text-slate-400 hover:text-red-500 hover:bg-red-50 transition-colors" data-testid={`admin-delete-vehicle-${v._id}`} title="Sil">
                <Trash2 className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        ))}
        {vehicles.length === 0 && <div className="text-center py-8 text-slate-500">Araç bulunamadı</div>}
      </div>
    </>
  );
}
